import { Injectable } from '@angular/core';
import { ITraveller, TGetBookingResponse } from '../../booking/interfaces/IGetBookings';
import { IIqbaRequest } from './interfaces/IIqbaRequest';
import { TravellerXTitle } from "../../booking/interfaces/get-bookings.enum";
import _cloneDeep from "lodash-es/cloneDeep";

@Injectable({
    providedIn: 'root'
})
export class IqbaRedirectionService {

    public redirectToIQBA(body: IIqbaRequest): void {
        let instanceUrl: string = `${window.location.protocol}//${window.location.hostname}`;

        if (window.location.port !== '') {
            instanceUrl = `${instanceUrl}:${window.location.port}`;
        }

        instanceUrl = `${instanceUrl}${sessionStorage.getItem("$instance_url")}wui/locobook`;

        sessionStorage.setItem("$post", JSON.stringify(body.json));
        window.open(instanceUrl, '_self');
    }

    public createIQBABody(booking: TGetBookingResponse): IIqbaRequest {
        const travellers: Array<{
            isReadonly: boolean,
            title: string,
            type: string,
            firstName: string,
            lastName: string,
            birthDate: string
        }> = [];

        if (booking.traveller) {
            booking.traveller.forEach((traveller: ITraveller): void => {
                travellers.push({
                    isReadonly: true,
                    title: TravellerXTitle[traveller.xTitle] ?? TravellerXTitle.mr,
                    type: upperCaseOnFirstLetter(traveller.xType),
                    firstName: traveller.firstName ?? null,
                    lastName: traveller.lastName ?? null,
                    birthDate: traveller.birthDate ?? null
                });
            });
        }
        //TODO+LA+ZB : add permission to show only summary of services
        const permission: {
            booking: {
                create: boolean
            },
            searchForm: {
                use: boolean
            },
            services: {
                use: boolean,
                show: boolean
            }
        } = {
            booking: {
                create: true
            },
            searchForm: {
                use: true
            },
            services: {
                use: false,
                show: true
            }
        };

        const bookingIQBAInfos: {
            code: string,
            syscode: string,
            owner: string,
            host: string
        } = {
            code: booking.code,
            syscode: booking.syscode,
            owner: booking.host,
            host: "TRAVELPORT"
        };
        return {
            json: {
                traveller: travellers,
                permission,
                booking: bookingIQBAInfos,
                agency: booking.agency,
                agent: booking.agent,
                host: bookingIQBAInfos.host
            }
        };
    }

}

function upperCaseOnFirstLetter(word: string): string {
    return word ? word[0].toUpperCase() + (word.slice(1) ?? "") : "";
}
